import { useIsAuthenticated } from '@refinedev/core';
import { Navigate, useLocation } from 'react-router';
import { TOKEN_EXPIRED_ERROR_NAME } from '@/providers/authProvider';
import { buildLoginPath } from '@/utils/loginPath';

/**
 * The `<Authenticated>` fallback: `<CatchAllNavigate>` plus the reason. When
 * check() failed because the session could not be refreshed, Login is told so
 * it can explain the sign-out instead of showing a bare form.
 */
export const LoginRedirect = (): React.JSX.Element => {
  const { pathname, search } = useLocation();
  // Reuse the result <Authenticated> just fetched; a refetch would see the
  // cleared session and lose the reason.
  const { data } = useIsAuthenticated({ queryOptions: { refetchOnMount: false } });
  const sessionEnded = data?.error?.name === TOKEN_EXPIRED_ERROR_NAME;

  return <Navigate to={buildLoginPath(`${pathname}${search}`, { sessionEnded })} />;
};
